import { FC } from "react";
import { useTranslation } from "react-i18next";
import CustomPopup from "../../../../custom-components/CustomPopup";

interface CreateReviewSuccessProps {
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}

const CreateReviewSuccess: FC<CreateReviewSuccessProps> = (props) => {
    const { t } = useTranslation();

    const closeHandler = () => props.setIsVisible(false);

    return (
        <CustomPopup
            isVisible={props.isVisible}
            setIsVisible={props.setIsVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
            confirmTitle={t("common.ok")}
            confirmHandler={closeHandler}
            closeHandler={closeHandler}
            confirmButtonClassName="w-[193px] dmax2:w-[133px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[320px] ti6:max-w-[320px] ti7:max-w-[280px] tmax4:max-w-[280px]">
                {t("reviews.successMessage")}
            </p>
        </CustomPopup>
    );
};

export default CreateReviewSuccess;
